export enum SELECTION_CATEGORY {
	EMPTY = 'empty',
	FULL_DOCUMENT = 'fullDocument',
	FULL_SINGLE_BLOCK = 'fullSingleBlock',
	PARTIAL_SINGLE_BLOCK = 'partialSingleBlock',
	FULL_MULTIPLE_BLOCKS = 'fullMultipleBlocks',
	PARTIAL_MULTIPLE_BLOCKS = 'partialMultipleBlocks',
}

/**
 * Type for node and mark type counts in a selection
 * Maps node/mark type names to their count occurrences
 */
export type NodeAndMarkCounts = { [key: string]: number };
